import { useEffect } from "react";

import { setPermanentSession } from "modules/Login/hooks";
import { useLogout } from "modules/Login/hooks/useLogout";

import type { ReactNode } from "react";

export const sessionBroadcastChannel = new BroadcastChannel("session");

export const BroadcastChannelManager = ({ children }: { children: ReactNode }) => {
  const logout = useLogout(false);

  useEffect(() => {
    const handleBroadcastMessage = (event: MessageEvent) => {
      if (event.data.type === "LOGOUT") logout();
      if (event.data.type === "LOGIN") setPermanentSession(event.data.session);
    };

    sessionBroadcastChannel.addEventListener("message", handleBroadcastMessage);
  }, []);

  return children;
};
